import ko from 'knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./tabs-list.template.html';
import CommonDialog from '../modal-dialog/common-dialog/common-dialog';
import UtilsService from '../../services/utils.service';
import $ from "jquery";
import PermissionService from "../../services/permission.service";
import PreferenceService from "../../services/preference.service";
import LoginService from "../../services/login.service";

function TabList(params) {
    var self = this;

    if (_.isNil(_.get(params, 'tabsList'))) {
        throw new Error('TabList :: Missing required parameters (tabsList).');
    }

    self.route = params.route;
    self.tabsList = params.tabsList;
    self.dataProvider = params.dataProvider;
    self.permissionService = new PermissionService(LoginService.userObject);
    self.dashboardIds = params.dashboardIds;

    self.selectedTabChangedSignal = _.get(params, 'signals.selectedTabChanged');
    self.tabRenamedSignal = _.get(params, 'signals.tabRenamed');
    self.tabAddedSignal = _.get(params, 'signals.tabAdded');
    self.tabRemovedSignal = _.get(params, 'signals.tabRemoved');

    if (!self.permissionService.hasPermission(self.permissionService.DashboardEditPermission)) {
        self.isEditable = ko.observable(false);
    } else {
        self.isEditable = ko.observable(!!ko.unwrap(params.isEditable));
    }
    self.selectedTabId = ko.observable();

    self.myView = self.route().view;

    self.subscriptions = [
        self.tabsList.subscribe(self.initializeSelectedTabId, self),

        self.selectedTabId.subscribe(function (updatedTabId) {
            UtilsService.dispatchSignal(self.selectedTabChangedSignal, updatedTabId);
        }, self),

        self.route.subscribe(function() {
            if (self.route().view === self.myView) {
                self.initializeSelectedTabId(self.tabsList());
            }
        })
    ];

    self.duplicateCurrentTab = function () {
        var unwrap = ko.unwrap(self.dashboardIds);

        return PreferenceService.getUserTabPreferences(LoginService.userObject.userId, unwrap.appId, unwrap.viewId, self.selectedTabId()).then(function (newTab) {
            if (_.isEmpty(newTab)) {
                throw new Error('tabs-list::duplicateCurrentTab - ' +
                    'Unable to load from board app: ' + from.appId + " view: " + from.viewId
                    + " tabId: " + tabId + " - board does not exist");
            }
            newTab.id = UtilsService.generateID();

            UtilsService.dispatchSignal(self.tabAddedSignal, {tab: newTab, callback: function() {
                self.tabsList.push({
                    id: newTab.id,
                    name: newTab.name
                });
                self.navigateToTabURI(newTab.id);
            }});
        });
    };

    // Added in the constructor so that it can retain their execution context. This is used
    // in the knockout:foreach context so the "this" reference is reassigned. To preserve
    // that we use the "self" pattern and a closure.
    self.deleteCurrentTab = function () {
        var prompt = 'Deleting this tab will remove all panels contained within. Do you wish to proceed?';
        CommonDialog
            .confirm(prompt)
            .then(function (confirmed) {
                if (confirmed) {
                    var selectedTabId = ko.unwrap(self.selectedTabId);
                    self.tabsList.remove(function (item) {
                        return item.id === selectedTabId;
                    });
                    UtilsService.dispatchSignal(self.tabRemovedSignal, selectedTabId);
                }
            });
    };

    function getDataForModal() {
        return ko.dataFor($('#share-dashboard-modal')[0].firstChild);
    }

    function getDataForModalAdvanced() {
        return ko.dataFor($('#share-dashboard-adv-modal')[0].firstChild);
    }

    function getDataForModalClearPreferencesAdvanced() {
        return ko.dataFor($('#clear-preferences-adv-modal')[0].firstChild);
    }

    self.shareCurrentTab = function () {
        var roomModal = getDataForModal();
        var unwrap = ko.unwrap(self.dashboardIds);

        roomModal.show({
            appId: unwrap.appId,
            viewId: unwrap.viewId,
            currentBoard: self.selectedTabId(),
            currentUserId: LoginService.userObject.userId,
        });
    };

    self.shareCurrentTabAdvanced = function () {
        var roomModal = getDataForModalAdvanced();
        var unwrap = ko.unwrap(self.dashboardIds);

        roomModal.show({
            appId: unwrap.appId,
            viewId: unwrap.viewId,
            currentBoard: self.selectedTabId(),
            currentUserId: LoginService.userObject.userId,
        });
    };


    self.clearPreferencesAdvanced = function () {
        var roomModal = getDataForModalClearPreferencesAdvanced();
        var unwrap = ko.unwrap(self.dashboardIds);

        roomModal.show({
            appId: unwrap.appId,
            viewId: unwrap.viewId,
            currentOrgId: LoginService.userObject.orgId,
            currentUserId: LoginService.userObject.userId,
        });
    };


    self.onTabClicked = function (tab) {
        self.navigateToTabURI(_.get(tab, 'id'));
    };
    
    self.buildTabHref = function(id) {
        return buildTabHref(id);
    }

    self.tabNameKeypress = function(element, event) {
        if (event.keyCode === 13) {
            self.saveTabName(element, event);
            event.target.blur();
        }
        return true;
    };
    self.saveTabName = function (element, data) {
        let selectedTabId = ko.unwrap(self.selectedTabId);
        let name = element.name;
        UtilsService.dispatchSignal(self.tabRenamedSignal, { id: selectedTabId, name: name });
    };
}

function buildTabHref(tabId) {
    var tabRegexp = new RegExp(/\/tabid\/(\w+)/);
    var url = location.href;
    url = url.replace(/\/params\/\S+/, ''); // remove /params param (if there)
    url = url.replace(/\/link\/\S+/, ''); // remove /link param (if there)

    return tabRegexp.test(url)
        ? url.replace(tabRegexp, '/tabid/' + tabId)
        : url + '/tabid/' + tabId;
}

function getDefaultTabName(tabsList) {
    var defaultTabNames = _
        .chain(tabsList)
        .map('name')
        .filter(function (tabName) {
            // tests for names with the following pattern: "New Dashboard xx"
            return /^New Dashboard \d+$/i.test(tabName);
        })
        .value();

    // Find and index that won't collide with an existing name
    var index = 1;
    var namePrefix = 'New Dashboard ';
    while (_.includes(defaultTabNames, namePrefix + index)) {
        index++;
    }

    return namePrefix + index;
}

function getTabIdFromURL() {
    var tokens = RegExp(/\/tabid\/(\w+)/).exec(location.href);
    return _.get(tokens, ['1']);
}

TabList.prototype = {
    addTab: function () {
        var self = this;
        var newTab = {
            id: UtilsService.generateID(),
            name: getDefaultTabName(ko.unwrap(self.tabsList))
        };
        UtilsService.dispatchSignal(self.tabAddedSignal, {tab: newTab, callback: function() {
            self.tabsList.push(newTab);
            self.navigateToTabURI(newTab.id);
        }}) ;
    },

    dispose: function () {
        var self = this;
        _.forEach(self.subscriptions, function (subscription) {
            subscription.dispose();
        });
    },

    initializeSelectedTabId: function (tabsListValue) {
        var self = this;
        var requestedTabId = getTabIdFromURL();

        let link = self.route().link;
        if (link) {
            self.selectedTabId(requestedTabId);
            return;
        }

        if (_.isEmpty(tabsListValue)) {
            return; // nothing to do here
        }

        // see if requested tab is in the list
        var tabId = _.get(_.find(tabsListValue, { id: requestedTabId }), 'id');

        if (_.isEmpty(tabId)) {
            // default to the first tab
            tabId = _.get(_.first(tabsListValue), 'id');
            self.navigateToTabURI(tabId, true);
        } else {
            self.selectedTabId(tabId);
        }
    },

    navigateToTabURI: function (tabId, replace) {
        var self = this;
        if (!_.isEmpty(tabId)) {
            self.selectedTabId(tabId);

            let url = buildTabHref(tabId);
            if (replace) {
                location.replace(url);
            } else {
                location.href = url;
            }
        }
    }
};

ko.components.register('tabs-list', { template: templateMarkup, viewModel: TabList });
